import { http } from "./http.js"
import { str } from "./str.js"
import { file } from "./file.js"
import { num } from "./num.js"
import { env } from "./env.js"
import { menu } from "./menu.js"
import { guid } from "./guid.js"
import { crypto } from "./crypto.js"
import { style } from "./style.js"
import { Enum } from "./enums.js"
import { URL } from "./url.js"
import { xdate } from "./xdate.js"
import { User } from "./user.js"
import { Cache } from "./cache.js"

function build(penv) {
    let main = {}
    main.session=new Cache(sessionStorage)
    main.cache=new Cache(localStorage)
    main.style = new style()
    main.http = new http()
    main.str = new str()
    main.file = new file()
    main.num = new num()
    main.enum = new Enum(main.session)
    main.user=new User(main.session)
    main.env = new env(main.http, main.enum, penv,main.user)
    main.menu = new menu()
    main.guid = new guid()
    main.crypto = new crypto()
    main.url = new URL(main.str)
    main.xdate=new xdate()
    return main
}

export default {
    load: function (penv) {
        return build(penv)
    },
}